/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';
import Moment from 'react-moment';
import 'moment-timezone';
import styled from 'styled-components';
import { isDef, isUndef } from '../../shared/utils/validations';

const colorWhite = { color: 'white' };

const Label = styled.label`
  font-size: 14px;
`;

const HoldTooltipBuilder = holdData => (
  <React.Fragment>
    <Label style={colorWhite}>
      <strong>Hold Status: </strong>
      These tickets are currently on hold.
    </Label>
    <br />
    <Label style={colorWhite}>
      <strong>Hold Notes: </strong>
      {holdData.notes}
    </Label>
    <br />
    <Label style={colorWhite}>
      <strong>Hold Placed By: </strong>
      {holdData.placed_by}
    </Label>
    <br />
    <Label style={colorWhite}>
      <strong>Hold Added: </strong>
      <Moment utc local parse="YYYY-MM-DD HH:mm:ss" format="MM/DD/YYYY hh:mm a ddd">
        {holdData.placed_datetime}
      </Moment>
    </Label>
    <br />
    <Label style={colorWhite}>
      <strong>Held Until: </strong>
      <Moment utc local parse="YYYY-MM-DD HH:mm:ss" format="MM/DD/YYYY hh:mm a ddd">
        {holdData.expiry_datetime}
      </Moment>
    </Label>
  </React.Fragment>
);

const renderLabel = text => <Label>{text}</Label>;

const tagsToCheck = ['nontransferable_rotating'];

const ListingsTooltip = memo(({ value, data }) => {
  if (isUndef(value) && isUndef(data)) {
    return null;
  }

  if (isDef(data) && data.hold) {
    return (
      <Tooltip title={HoldTooltipBuilder(data.hold)}>
        <div style={{ minWidth: 80 }}>
          <span>{value}</span>
        </div>
      </Tooltip>
    );
  }

  if (isDef(data) && data.qcStatus) {
    return (
      <Tooltip
        title={renderLabel(
          "These tickets are currently in the process of being QC'd. Once the QC process has concluded, these tickets will be released and be ready to price."
        )}
      >
        <div style={{ minWidth: 80 }}>
          <span>{value}</span>
        </div>
      </Tooltip>
    );
  }

  if (data && data.tags) {
    if (tagsToCheck.some(t => data.tags.includes(t))) {
      return (
        <Tooltip title={renderLabel('This list is considered non-transferable')}>
          <div style={{ minWidth: 80 }}>
            <span>{value}</span>
          </div>
        </Tooltip>
      );
    }
  }

  return value;
});

ListingsTooltip.propTypes = {
  // eslint-disable-next-line react/require-default-props
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.object.isRequired,
};

export default ListingsTooltip;
